import {
  initializeFaro,
  getWebInstrumentations,
  ReactIntegration,
  faro,
} from '@grafana/faro-react'

import { version } from '../../../package.json'

const configure = () => {
  const collectorUrl = process.env.REACT_APP_FARO_COLLECTOR_URL
  if (!collectorUrl) {
    return
  }

  initializeFaro({
    app: {
      environment: process.env.REACT_APP_ENVIRONMENT || 'development',
      name: 'crowdsegment',
      version,
    },
    instrumentations: [...getWebInstrumentations(), new ReactIntegration()],
    url: collectorUrl,
  })
}

const setUserContext = user => {
  if (faro.api) {
    faro.api.setUser({
      email: user.email,
      id: user.id,
    })
  }
}

const report = (error, query) => {
  if (faro.api) {
    faro.api.pushError(error, {
      context: { query: String(query) },
    })
  }
}

export default {
  configure,
  report,
  setUserContext,
}
